// extracted by mini-css-extract-plugin
export default {"layout":"_66cb315ae2 fe73c9f58f bc2999ef22","h_slide":"_37fb396a49","category":"bdab24b7b3 _1b7e7295c2 _29e361b0c5"};